module.exports = __webpack_public_path__ + "staticcomp/img/share.b53713e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/8/share.jpg
// module id = 7t4h
// module chunks = 39